export default __webpack_public_path__ + "static/media/emergency_alarm.31200a7e.mp3";